import React, { useEffect, useState } from "react";
import { Card, Col, Select, Statistic, Row, Table, Tag, message } from "antd";

import ReportFilterBar from "../components/ReportFilterBar";
import ReportExportButton from "../components/ReportExportButton";
import { fetchTaskReportApi } from "../../../apiservice/crm";

const BUCKET_COLOR = {
  overdue: "red",
  today: "orange",
  upcoming: "blue",
  completed: "green",
  cancelled: "default",
};

const TaskReports = () => {
  const [filters, setFilters] = useState({});
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({ overdue: 0, today: 0, upcoming: 0, completed: 0, cancelled: 0 });
  const [loading, setLoading] = useState(false);

  const load = async (nextFilters = filters) => {
    setLoading(true);
    try {
      const res = await fetchTaskReportApi(nextFilters);
      setData(res.data?.data || []);
      setSummary(res.data?.summary || {});
    } catch (err) {
      message.error(err?.response?.data?.message || "Failed to load task report");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const columns = [
    { title: "Type", dataIndex: "type" },
    { title: "Due Date", dataIndex: "due_date" },
    { title: "Customer", dataIndex: "customer_name" },
    { title: "Assigned To", dataIndex: "assigned_user" },
    {
      title: "Bucket",
      dataIndex: "bucket",
      render: (v) => <Tag color={BUCKET_COLOR[v] || "default"}>{v}</Tag>,
    },
    { title: "Status", dataIndex: "status" },
  ];

  return (
    <>
      <ReportFilterBar
        filters={filters}
        onChange={(partial) => setFilters((f) => ({ ...f, ...partial }))}
        onApply={() => load()}
        onReset={() => {
          setFilters({});
          load({});
        }}
        loading={loading}
        extra={
          <Col xs={24} sm={12} md={8} lg={4}>
            <label>Bucket</label>
            <Select
              allowClear
              placeholder="All"
              style={{ width: "100%" }}
              size="large"
              value={filters.bucket || undefined}
              onChange={(v) => {
                const next = { ...filters, bucket: v || null };
                setFilters(next);
                load(next);
              }}
              options={[
                { label: "Overdue", value: "overdue" },
                { label: "Today", value: "today" },
                { label: "Upcoming", value: "upcoming" },
                { label: "Completed", value: "completed" },
              ]}
            />
          </Col>
        }
      />

      <Card title="Follow-up / Overdue Tasks" extra={<ReportExportButton reportType="tasks" filters={filters} />}>
        <Row gutter={16} className="mb-4">
          <Col><Statistic title="Overdue" value={summary.overdue || 0} valueStyle={{ color: "#cf1322" }} /></Col>
          <Col><Statistic title="Today" value={summary.today || 0} /></Col>
          <Col><Statistic title="Upcoming" value={summary.upcoming || 0} /></Col>
          <Col><Statistic title="Completed" value={summary.completed || 0} /></Col>
        </Row>

        <Table
          rowKey="task_id"
          columns={columns}
          dataSource={data}
          loading={loading}
          bordered
          scroll={{ x: "max-content" }}
        />
      </Card>
    </>
  );
};

export default TaskReports;
